// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `intro-flow-page {
  --top-banner-height: 170px;
  --bottom-banner-height: 170px;
  --banner-roll-time: 1s;
  height: 100%;
}
intro-flow-page .intro-flow-page.dark-bg {
  background-color: var(--motes-dark);
}
intro-flow-page .intro-flow-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100vw;
  box-sizing: border-box;
  padding: 0 var(--motes-padding);
}
intro-flow-page .intro-flow-page .all-pointer-events {
  pointer-events: initial;
}
intro-flow-page .intro-flow-page .top-banner, intro-flow-page .intro-flow-page .bottom-banner {
  display: flex;
  background-color: var(--motes-dark);
  box-sizing: border-box;
  width: 100vw;
  padding: var(--motes-padding);
}
intro-flow-page .intro-flow-page .top-banner {
  justify-content: center;
  height: var(--top-banner-height);
  align-items: center;
  padding-top: calc(var(--safe-area-top) + var(--large-spacing) + var(--large-spacing));
}
intro-flow-page .intro-flow-page .top-banner .storyhunt-logo {
  padding: var(--motes-padding) 0;
  box-sizing: border-box;
  margin-top: var(--large-spacing);
}
intro-flow-page .intro-flow-page .top-banner .header {
  color: #fff;
  font-size: 20pt;
  margin-bottom: 0;
}
intro-flow-page .intro-flow-page .top-banner .header:after {
  content: "";
  display: block;
  margin: 0 auto;
  padding-top: var(--motes-padding);
  border-bottom: 2px solid var(--primary-color);
  width: 100px;
}
intro-flow-page .intro-flow-page .bottom-banner {
  height: var(--bottom-banner-height);
  justify-content: flex-end;
  flex-direction: column;
  padding-bottom: calc(4 * var(--motes-padding));
}
intro-flow-page .intro-flow-page .top-banner.roll-out {
  transform: translateY(calc(-1 * (var(--top-banner-height))));
  transition: transform var(--banner-roll-time) ease-out;
}
intro-flow-page .intro-flow-page .bottom-banner.roll-out {
  transform: translateY(var(--bottom-banner-height));
  transition: transform var(--banner-roll-time) ease-out;
}
intro-flow-page .intro-flow-page .tour-image-container {
  width: 100%;
  padding: 0;
  box-sizing: border-box;
}
intro-flow-page .intro-flow-page .map-bg-window {
  flex-grow: 2;
  width: 100vw;
  position: relative;
  box-shadow: inset 0px 60px 30px -30px var(--motes-dark), inset 0px -60px 30px -30px var(--motes-dark);
}
intro-flow-page .intro-flow-page .map-bg-window tutorial-animation {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
intro-flow-page .intro-flow-page .group-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  max-width: var(--max-width);
  background: transparent;
  box-shadow: none;
}
intro-flow-page .intro-flow-page .trailer-container {
  width: 100vw;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
intro-flow-page .intro-flow-page .trailer-container motes-media {
  width: 100%;
  max-width: 1024px;
}
intro-flow-page .intro-flow-page .grow-1 {
  flex-grow: 1;
}
intro-flow-page .intro-flow-page h1 {
  text-align: center;
}
intro-flow-page .intro-flow-page .description {
  width: 100%;
  color: #fff;
}
intro-flow-page .intro-flow-page .description .tour-title {
  text-transform: uppercase;
  font-family: "Century Gothic", Gothic, sans-serif;
  font-size: 15pt;
}
intro-flow-page .intro-flow-page .description .tour-preview {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
intro-flow-page .intro-flow-page .description p {
  margin-bottom: 0;
  font-size: 16px;
  line-height: 25px;
}
intro-flow-page .intro-flow-page .description a {
  color: var(--primary-color);
}
intro-flow-page .intro-flow-page .buttons {
  width: 100%;
  padding-top: var(--motes-padding);
}
intro-flow-page .intro-flow-page .buttons button {
  border: none;
  color: black;
  margin: 0;
}
intro-flow-page .intro-flow-page .buttons, intro-flow-page .intro-flow-page .description, intro-flow-page .intro-flow-page .tour-image-container, intro-flow-page .intro-flow-page .storyhunt-logo {
  max-width: var(--max-width);
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/intro-flow-page/intro-flow-page.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,6BAAA;EACA,sBAAA;EAEA,YAAA;AAAJ;AAEI;EACI,mCAAA;AAAR;AAGI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,+BAAA;AADR;AAGQ;EACI,uBAAA;AADZ;AAIQ;EACI,aAAA;EACA,mCAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;AAFZ;AAKQ;EACI,uBAAA;EACA,gCAAA;EACA,mBAAA;EACA,qFAAA;AAHZ;AAKY;EACI,+BAAA;EACA,sBAAA;EACA,gCAAA;AAHhB;AAMY;EACI,WAAA;EACA,eAAA;EACA,gBAAA;AAJhB;AAOY;EACI,WAAA;EACA,cAAA;EACA,cAAA;EACA,iCAAA;EACA,6CAAA;EACA,YAAA;AALhB;AASQ;EACI,mCAAA;EACA,yBAAA;EACA,sBAAA;EACA,8CAAA;AAPZ;AAUQ;EACI,4DAAA;EACA,sDAAA;AARZ;AAWQ;EACI,kDAAA;EACA,sDAAA;AATZ;AAYQ;EACI,WAAA;EACA,UAAA;EACA,sBAAA;AAVZ;AAaQ;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,qGAAA;AAXZ;AAaY;EACI,kBAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAXhB;AAeQ;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,gBAAA;AAbZ;AAgBQ;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAdZ;AAgBY;EACI,WAAA;EACA,iBAAA;AAdhB;AAkBQ;EACI,YAAA;AAhBZ;AAmBQ;EACI,kBAAA;AAjBZ;AAoBQ;EACI,WAAA;EACA,WAAA;AAlBZ;AAoBY;EACI,yBAAA;EACA,iDAAA;EACA,eAAA;AAlBhB;AAqBY;EACI,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAnBhB;AAsBY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AApBhB;AAuBY;EACI,2BAAA;AArBhB;AAyBQ;EACI,WAAA;EACA,iCAAA;AAvBZ;AAyBY;EACI,YAAA;EACA,YAAA;EACA,SAAA;AAvBhB;AA2BQ;EACI,2BAAA;EACA,cAAA;AAzBZ","sourcesContent":["intro-flow-page {\n    --top-banner-height: 170px;\n    --bottom-banner-height: 170px;\n    --banner-roll-time: 1s;\n    \n    height: 100%;\n\n    .intro-flow-page.dark-bg {\n        background-color: var(--motes-dark);\n    }\n\n    .intro-flow-page {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        height: 100%;\n        width: 100vw;\n        box-sizing: border-box;\n        padding: 0 var(--motes-padding);\n\n        .all-pointer-events {\n            pointer-events: initial;\n        }\n\n        .top-banner, .bottom-banner {\n            display: flex;\n            background-color: var(--motes-dark);\n            box-sizing: border-box;\n            width: 100vw;\n            padding: var(--motes-padding);\n        }\n        \n        .top-banner {\n            justify-content: center;\n            height: var(--top-banner-height);\n            align-items: center;\n            padding-top: calc(var(--safe-area-top) + var(--large-spacing) + var(--large-spacing));\n\n            .storyhunt-logo {\n                padding: var(--motes-padding) 0;\n                box-sizing: border-box;\n                margin-top: var(--large-spacing);\n            }\n    \n            .header {\n                color: #fff;\n                font-size: 20pt;\n                margin-bottom: 0;\n            }\n            \n            .header:after {\n                content: \"\";\n                display: block;\n                margin: 0 auto;\n                padding-top: var(--motes-padding);\n                border-bottom: 2px solid var(--primary-color);\n                width: 100px;\n            }\n        }\n\n        .bottom-banner {\n            height: var(--bottom-banner-height);\n            justify-content: flex-end;\n            flex-direction: column;\n            padding-bottom: calc(4 * var(--motes-padding));\n        }\n\n        .top-banner.roll-out {\n            transform: translateY(calc(-1 * (var(--top-banner-height))));\n            transition: transform var(--banner-roll-time) ease-out;;\n        }\n\n        .bottom-banner.roll-out {\n            transform: translateY(var(--bottom-banner-height));\n            transition: transform var(--banner-roll-time) ease-out;;\n        }\n        \n        .tour-image-container {\n            width: 100%;\n            padding: 0;\n            box-sizing: border-box;\n        }\n        \n        .map-bg-window {\n            flex-grow: 2;\n            width: 100vw;\n            position: relative;\n            box-shadow: inset 0px 60px 30px -30px var(--motes-dark), inset 0px -60px 30px -30px var(--motes-dark);\n            \n            tutorial-animation {\n                position: absolute;\n                top: 0;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                width: 100%;\n                height: 100%;\n            }\n        }\n\n        .group-container {\n            width: 100%;\n            height: 100%;\n            box-sizing: border-box;\n            max-width: var(--max-width);\n            background: transparent;\n            box-shadow: none;\n        }\n\n        .trailer-container {\n            width: 100vw;\n            max-height: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            overflow: hidden;\n\n            motes-media {\n                width: 100%;\n                max-width: 1024px;\n            }\n        }\n        \n        .grow-1 {\n            flex-grow: 1;\n        }\n\n        h1 {\n            text-align: center;\n        }\n\n        .description {\n            width: 100%;\n            color: #fff;\n\n            .tour-title {\n                text-transform: uppercase;\n                font-family: \"Century Gothic\", Gothic, sans-serif;\n                font-size: 15pt;\n            }\n\n            .tour-preview {\n                display: -webkit-box;\n                -webkit-line-clamp: 3;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n\n            p {\n                margin-bottom: 0;\n                font-size: 16px;\n                line-height: 25px;\n            }\n\n            a {\n                color: var(--primary-color);\n            }\n        }\n\n        .buttons {\n            width: 100%;\n            padding-top: var(--motes-padding);\n\n            button {\n                border: none;\n                color: black;\n                margin: 0;\n            }\n        }\n        \n        .buttons, .description, .tour-image-container, .storyhunt-logo {\n            max-width: var(--max-width);\n            margin: 0 auto;\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
